module.exports = __webpack_public_path__ + "static/media/alexis-bledel.3d985294.jpg";